// front-end/src/components/news-loader/home-news-loader.js

import {apiGet} from '../../utils/api';
import {config} from '../../config/app-config';
import {applyContentToElement, loadContentForElement} from '../content-editor-src';

export class HomeNewsLoader {
    constructor() {
        console.log('[HomeNewsLoader] Инициализация начата');
        this.container = null;
        this.init();
    }

    init() {
        console.log('[HomeNewsLoader] init() - начало');
        const currentPage = document.body.getAttribute('data-page');
        console.log('[HomeNewsLoader] Текущая страница:', currentPage);

        // Инициализируем только на главной странице
        if (currentPage === 'Home') {
            console.log('[HomeNewsLoader] Страница Home - ищем контейнер');
            this.container = document.getElementById('published-news-container');
            console.log('[HomeNewsLoader] Контейнер найден:', !!this.container);

            if (this.container) {
                console.log('[HomeNewsLoader] Запускаем загрузку новостей');
                this.loadPublishedNews();
            } else {
                console.warn('[HomeNewsLoader] Контейнер published-news-container не найден!');
            }
        } else {
            console.log('[HomeNewsLoader] Не главная страница, пропускаем инициализацию');
        }
    }

    async loadPublishedNews() {
        console.log('[HomeNewsLoader] loadPublishedNews() - начало');

        try {
            const apiUrl = `${config.api.paths.newsPublishedTop}?limit=10`; // Загружаем больше, чтобы отфильтровать кейсы
            console.log('[HomeNewsLoader] API URL:', apiUrl);
            console.log('[HomeNewsLoader] Отправляем запрос...');

            // Загружаем только опубликованные новости
            const response = await apiGet(apiUrl, {auth: false});

            console.log('[HomeNewsLoader] Ответ получен:', response);

            // API может возвращать либо массив напрямую, либо объект с полем items
            let newsItems = null;
            if (Array.isArray(response)) {
                console.log('[HomeNewsLoader] API вернул массив напрямую');
                newsItems = response;
            } else if (response && response.items && Array.isArray(response.items)) {
                console.log('[HomeNewsLoader] API вернул объект с полем items');
                newsItems = response.items;
            }

            console.log('[HomeNewsLoader] Финальный массив новостей:', newsItems);
            console.log('[HomeNewsLoader] Количество новостей:', newsItems?.length);

            if (newsItems && newsItems.length > 0) {
                // ВАЖНО: Фильтруем кейсы - оставляем только настоящие новости
                const realNews = newsItems.filter(item => {
                    const isCase = item.slug && item.slug.startsWith('case-');
                    if (isCase) {
                        console.log(`[HomeNewsLoader] Фильтруем кейс: ${item.slug}`);
                    }
                    return !isCase;
                });

                console.log(`[HomeNewsLoader] После фильтрации кейсов осталось ${realNews.length} новостей`);

                // Берем только первые 3 новости
                const topNews = realNews.slice(0, 3);

                if (topNews.length > 0) {
                    console.log('[HomeNewsLoader] Есть данные, рендерим новости');
                    await this.renderNews(topNews);
                } else {
                    console.log('[HomeNewsLoader] Нет новостей после фильтрации, показываем пустое состояние');
                    this.renderEmptyState();
                }
            } else {
                console.log('[HomeNewsLoader] Нет данных, показываем пустое состояние');
                this.renderEmptyState();
            }
        } catch (error) {
            console.error('[HomeNewsLoader] Ошибка при загрузке новостей:', error);
            console.error('[HomeNewsLoader] Stack trace:', error.stack);
            this.renderErrorState();
        }
    }

    async renderNews(newsItems) {
        console.log('[HomeNewsLoader] renderNews() - начало');
        console.log('[HomeNewsLoader] Количество новостей для рендера:', newsItems.length);

        this.container.innerHTML = '';

        for (let i = 0; i < newsItems.length; i++) {
            const news = newsItems[i];
            console.log(`[HomeNewsLoader] Обрабатываем новость ${i + 1}:`, news);
            console.log(`[HomeNewsLoader] News slug: ${news.slug}, title: ${news.title}`);

            try {
                const newsElement = this.createNewsElement(news);
                console.log(`[HomeNewsLoader] HTML элемент создан для новости ${i + 1}`);

                this.container.appendChild(newsElement);
                console.log(`[HomeNewsLoader] Элемент добавлен в контейнер для новости ${i + 1}`);

                // Загружаем контент для каждого элемента новости
                await this.loadNewsContent(newsElement, news);
                console.log(`[HomeNewsLoader] Контент загружен для новости ${i + 1}`);
            } catch (error) {
                console.error(`[HomeNewsLoader] Ошибка при обработке новости ${i + 1}:`, error);
            }
        }

        console.log('[HomeNewsLoader] renderNews() - завершено');
    }

    createNewsElement(news) {
        console.log('[HomeNewsLoader] createNewsElement() для:', news.slug);

        const newsHref = news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`;

        const newsItem = document.createElement('div');
        newsItem.className = 'news-preview container-fluid d-flex d-md-block justify-content-between';
        newsItem.style.cursor = 'pointer';
        newsItem.addEventListener('click', (e) => {
            if (!e.target.closest('a')) {
                window.location.href = newsHref;
            }
        });
        //language=HTML
        newsItem.innerHTML = `
            <div class="row">
                <div class="col-lg-6 col-md-6 flex-column flex-md-row justify-content-md-between justify-content-center row-gap-0 news-preview-meta">
                    <p class="publication-date-news-home" data-content="${news.slug}-date" data-global="true"
                       data-type="date"></p>
                    <img class="news-home-image" src="" alt="News Image" data-content="${news.slug}-image" data-type="image" data-global="true">
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                        <div class="col-md-10">
                            <h5 data-content="${news.slug}-title" data-global="true"></h5>
                            <p class="news-home-description" data-content="${news.slug}-description"
                               data-type="textarea" data-global="true"></p>
                        </div>
                        <div class="col-md-2 d-none d-md-block">
                            <a href="${news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`}" class="news-link active">
                                <img src="images/news-button.svg" alt="news-button" class="news-button default">
                                <img src="images/news-button-hover.svg" alt="news-button-hover"
                                     class="news-button hover">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-md-none">
                <a href="${news.slug && news.slug.startsWith('case-') ? `/case/${news.slug}` : `/news/${news.slug}`}" class="news-link active">
                    <img src="images/news-button.svg" alt="news-button" class="news-button default">
                    <img src="images/news-button-hover.svg" alt="news-button-hover" class="news-button hover">
                </a>
            </div>
        `;

        console.log('[HomeNewsLoader] HTML элемент создан успешно');
        return newsItem;
    }

    async loadNewsContent(newsElement, news) {
        console.log('[HomeNewsLoader] loadNewsContent() - начало для:', news.slug);

        const contentElements = newsElement.querySelectorAll('[data-content]');
        console.log('[HomeNewsLoader] Найдено элементов с data-content:', contentElements.length);

        for (let i = 0; i < contentElements.length; i++) {
            const element = contentElements[i];
            const tagId = element.getAttribute('data-content');
            const isGlobal = element.getAttribute('data-global') === 'true';

            console.log(`[HomeNewsLoader] Загружаем контент для элемента ${i + 1}: ${tagId}, global: ${isGlobal}`);

            try {
                const data = await loadContentForElement(element, '', tagId, isGlobal);
                console.log(`[HomeNewsLoader] Данные получены для ${tagId}:`, data);

                if (data) {
                    applyContentToElement(element, data);
                    console.log(`[HomeNewsLoader] Контент применен для ${tagId}`);
                } else {
                    console.log(`[HomeNewsLoader] Нет данных для ${tagId}, устанавливаем дефолтное значение`);
                    // Устанавливаем значения по умолчанию если контент не найден
                    this.setDefaultContent(element, news, tagId);
                }
            } catch (error) {
                console.warn(`[HomeNewsLoader] Ошибка загрузки контента для ${tagId}:`, error);
                console.warn(`[HomeNewsLoader] Error stack для ${tagId}:`, error.stack);
                this.setDefaultContent(element, news, tagId);
            }
        }

        console.log('[HomeNewsLoader] loadNewsContent() - завершено для:', news.slug);
    }

    setDefaultContent(element, news, tagId) {
        console.log('[HomeNewsLoader] setDefaultContent() для:', tagId);
        console.log('[HomeNewsLoader] News data:', {
            published_at: news.published_at,
            created_at: news.created_at,
            title: news.title,
            preview_text: news.preview_text
        });

        if (tagId.endsWith('-date')) {
            const formattedDate = this.formatDate(news.published_at || news.created_at);
            element.textContent = formattedDate;
            console.log('[HomeNewsLoader] Установлена дата:', formattedDate);
        } else if (tagId.endsWith('-title')) {
            element.textContent = news.title;
            console.log('[HomeNewsLoader] Установлен заголовок:', news.title);
        } else if (tagId.endsWith('-description')) {
            element.textContent = news.preview_text || '';
            console.log('[HomeNewsLoader] Установлено описание:', news.preview_text);
        }
    }

    formatDate(dateString) {
        console.log('[HomeNewsLoader] formatDate() для:', dateString);

        if (!dateString) {
            console.log('[HomeNewsLoader] Пустая дата, возвращаем пустую строку');
            return '';
        }

        try {
            const date = new Date(dateString);
            console.log('[HomeNewsLoader] Parsed date:', date);

            if (isNaN(date.getTime())) {
                console.warn('[HomeNewsLoader] Невалидная дата:', dateString);
                return '';
            }

            const months = [
                'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
                'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
            ];

            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();

            const result = `${day} ${month} ${year}`;
            console.log('[HomeNewsLoader] Отформатированная дата:', result);

            return result;
        } catch (error) {
            console.error('[HomeNewsLoader] Ошибка форматирования даты:', error);
            return '';
        }
    }

    renderEmptyState() {
        console.log('[HomeNewsLoader] renderEmptyState()');
        this.container.innerHTML = `
      <div class="news-empty-state">
        <p>Новини скоро з'являться</p>
      </div>
    `;
    }

    renderErrorState() {
        console.log('[HomeNewsLoader] renderErrorState()');
        this.container.innerHTML = `
      <div class="news-error-state">
        <p>Не вдалося завантажити новини</p>
      </div>
    `;
    }
}

// Создаем и экспортируем экземпляр
console.log('[HomeNewsLoader] Создаем экземпляр');
export const homeNewsLoader = new HomeNewsLoader();